import React, { useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { useMutation, useQuery } from "@apollo/client";
import { GET_ALL_Video, jump_mantra } from "../../gql/queries";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import NoDataFound from "../common/NoDataFound/NoDataFound";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { decrypt } from "../../utils/crypto";
import ConnectionError from "../common/NoDataFound/ConnectionError";
const INITIAL_STATE = {
    peralcode: "",
};
export default function MantraListing() {
    const navigate = useNavigate()
    const completePathUrl = useLocation()
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const [getProfileDetails, profileDetails] = useState(INITIAL_STATE);
    const [enable, setDisabled] = useState(true)
    const query1 = useQuery(GET_ALL_Video, {
        variables: {
            "courseName": course.preparingFor,
            "version": 0.0,
            "status": true,
            "contentType": "pearl",
            "isRoot": true
        },
    });
    if (query1.loading) {
        return (<><Loader /></>)
    }
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={completePathUrl.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={completePathUrl.pathname} />
                    </div>
                </div>
            </>)

        }
        console.log(query1.error);
    }


    const handleInputChange = function (fieldValue, fieldName) {
        profileDetails({ ...getProfileDetails, [fieldName]: fieldValue })
        if (!fieldValue) {
            setDisabled(true)
        } else {
            setDisabled(false)
        }

    }
    return (
        <div className="main_wrapper">
            <div className="breadcrumbs">
                <ul className="breadcrumb">
                    <li className="breadcrumb-item"><a >Home</a></li>
                    <li className="breadcrumb-item active"><a >Mantras</a></li>
                </ul>
            </div>
            <section className="videoLayer_wrapper mantras_wrapper section_side_padding">
                <div className="row">
                    <div className="col-lg-8 col-md-7 col-sm-12" id="mantraFirst">
                        <div className="subjects_wrapper">
                            <div className="subjects_header">
                                <h6>Mantras</h6>
                            </div>
                            <div className="all_subjects_name_wrapper">
                                <ul type="none" className="subjects_child d-flex flex-wrap">
                                    {
                                        query1.data && query1.data.layers.map(d => (
                                            <li>
                                                <Link to={`/mantras/mantraslisting/${d._id}`}>
                                                    <div className="subject_main_list d-flex align-items-center">
                                                        <div className="subject_img_wrap d-flex align-items-center">
                                                            <figure className="subject_img">
                                                                <img src={d.icon ? d.icon : Images.defaultImg} alt="" className="img-fluid" />
                                                            </figure>
                                                            <div className="subject_details">
                                                                <h6>{d.title}</h6>
                                                                {/* <p>{d.description}</p> */}
                                                            </div>
                                                        </div>
                                                        <div className="progressbar_wraper">
                                                            <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                        </div>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))
                                    }
                                    {/* <li>
                                        <div className="subject_main_list d-flex align-items-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Micro} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Microbiology</h6>
                                                    <p>Dr.Ashwani Kumar</p>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="subject_main_list d-flex align-items-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Micro} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Physiology</h6>
                                                    <p>Dr.Ashwani Kumar</p>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="subject_main_list d-flex align-items-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Micro} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Forensic Medicine</h6>
                                                    <p>Dr.Ashwani Kumar</p>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                            </div>
                                        </div>
                                    </li> */}
                                </ul>
                            </div>
                            {query1.data.layers.length === 0 && <NoDataFound />}

                        </div>

                    </div>
                    <div className="col-lg-4 col-md-5 col-sm-12" id="jump">
                        <div className="videos_wrapper">
                            <div className="recommended_video_wrapper">
                                <div className="subjects_header">
                                    <h6>Jump To Mantra</h6>
                                    <p>If you know any mantra number you can add it here to jump to it</p>
                                </div>
                                <div className="mantra_jump d-flex align-items-center">
                                    <div className="form-group">
                                        <input type="text" className="form-control" placeholder="Enter mantra number" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'peralcode')} />
                                    </div>
                                    <div className="jump_btn">
                                        <Link to={`/mantras/mantrascontent/${0}/${getProfileDetails.peralcode}/jump/0`} state={JSON.stringify({})}>
                                            <button type="button" className="btn btn_jump" disabled={enable}>Jump <img src={Icons.ArrWhite} alt="" className="img-fluid" /></button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div></section>
        </div>
    )
}